<template>
  <v-container fluid>
    <base-material-card color="#1e293b" class="px-5 py-3">
      <template v-slot:heading>
        <div class="font-weight-light">สาขาวิชาเอก</div>

        <h2 class="font-weight-light">
          ข้อมูลสาขาวิชา : การย้าย/เงือนไขการย้าย สายการสอน
        </h2>
      </template>
      <v-card-text>
        <v-data-table
          :headers="header_branchs"
          :items="showbranchdata"
          :search="search_branch"
        >
          <template v-slot:top>
            <v-row no-gutters align="center" class="px-4 pt-2">
              <v-col cols="12" sm="8">
                <v-text-field
                  v-model="search_branch"
                  label="ค้นหา :"
                  class="mr-4"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" class="text-sm-right">
                <v-btn outlined color="#1e293b" @click="exportData">
                  <v-icon left small>mdi-file-excel</v-icon>
                  ส่งออกข้อมูล
                </v-btn>
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-card-text>
    </base-material-card>
  </v-container>
</template>

<script>
import * as XLSX from "xlsx";

export default {
  name: "HRvecReportColleges",

  data() {
    return {
      ApiKey: "HRvec2021",
      header_branchs: [
        { text: "รหัสสาขา", align: "center", value: "id_branch" },
        { text: "สาขาวิชา", align: "left", value: "name_branch" },
        { text: "รายละเอียด", align: "left", value: "detail_branch" }
      ],
      showbranchdata: [],
      search_branch: ""
    };
  },

  async mounted() {
    await this.getAllbranchdata();
  },

  methods: {
    async getAllbranchdata() {
      let result = await this.$http.post("branch.php", {
        ApiKey: this.ApiKey
      });
      this.showbranchdata = result.data;
    },

    exportData() {
      try {
        const exportRows = this.showbranchdata.map(item => ({
          'รหัสสาขา': item.id_branch,
          'สาขาวิชา': item.name_branch,
          'รายละเอียด': item.detail_branch
        }));

        const ws = XLSX.utils.json_to_sheet(exportRows);
        ws["!cols"] = [{ wch: 14 }, { wch: 30 }, { wch: 50 }];

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "สาขาวิชา");

        const dateStr = new Date().toISOString().split('T')[0];
        XLSX.writeFile(wb, `ข้อมูลสาขาวิชา_${dateStr}.xlsx`);
      } catch (error) {
        console.error('Export error:', error);
      }
    }
  }
};
</script>
